export default "__VITE_PUBLIC_ASSET__b2c6c784__"